import { featuredCards } from '@/mocks/guaHome';

export default function FeaturedGrid() {
  return (
    <section id="featured" className="scroll-mt-20 bg-white">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mb-8 flex items-end justify-between gap-4 md:mb-10">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-8 items-center rounded-full bg-red-600/10 px-3 text-xs font-bold tracking-widest text-red-600">03 · 精选</span>
              <span className="text-xs font-medium tracking-widest text-stone-400 uppercase">Featured</span>
            </div>
            <h2 className="font-serif-sc mt-3 text-2xl font-bold text-stone-900 md:text-3xl">往期精选 · 图文复盘流</h2>
            <p className="mt-2 max-w-xl text-sm text-stone-500">近一周重点往期帖，图文并排复盘，边看配图边补上下文。</p>
          </div>
          <div className="hidden items-center gap-1 rounded-full border border-stone-200 bg-stone-50 p-1 md:flex" role="tablist" aria-label="精选筛选">
            {['综合', '绯闻瓜', '直播瓜', '综艺瓜'].map((t) => (
              <button
                key={t}
                type="button"
                className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                  t === '综合' ? 'bg-stone-900 text-white' : 'text-stone-500 hover:text-stone-800'
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 xl:grid-cols-4">
          {featuredCards.map((c) => (
            <article
              key={c.id}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-stone-200/80 bg-white transition-all hover:-translate-y-1 hover:border-red-200"
            >
              <div className="relative aspect-[14/9] w-full overflow-hidden bg-stone-100">
                <img
                  src={c.img}
                  alt={c.title}
                  title={`${c.title} | 53吃瓜往期精选`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-white/90 px-2.5 py-1 text-xs font-bold text-red-600 backdrop-blur">
                  {c.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="line-clamp-2 text-[15px] font-bold leading-snug text-stone-900 group-hover:text-red-600">{c.title}</h3>
                <p className="mt-2 line-clamp-2 text-[13px] leading-relaxed text-stone-500">{c.excerpt}</p>
                <div className="mt-auto flex items-center justify-between pt-4 text-xs text-stone-400">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-calendar-line" />
                    {c.date}
                  </span>
                  <span className="flex items-center gap-3">
                    <span className="flex items-center gap-1"><i className="ri-eye-line" />{c.views}</span>
                    <span className="flex items-center gap-1"><i className="ri-chat-3-line" />{c.comments}</span>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-8 flex justify-center">
          <a
            href="#archive"
            className="flex items-center gap-2 whitespace-nowrap rounded-full border border-stone-300 bg-white px-6 py-3 text-sm font-bold text-stone-800 transition-colors hover:border-stone-900 hover:bg-stone-900 hover:text-white"
          >
            查看更多往期精选
            <i className="ri-add-line" />
          </a>
        </div>
      </div>
    </section>
  );
}